module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('serviceTerms.message'))
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78e09ee5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Terms.vue
// module id = 459
// module chunks = 0